import React from "react";
import { SxStyleProp } from "theme-ui";
import { Box, BoxProps } from "rebass";

const variants = {
  primary: {
    bg: "primary",
  },
  outline: {
    color: "primary",
    bg: "transparent",
    boxShadow: "inset 0 0 0 2px",
  },
};

export interface Props extends React.HTMLAttributes<HTMLButtonElement> {
  sx?: SxStyleProp;
  css?: any;
  variant?: keyof typeof variants;
}

const Button: React.FunctionComponent<Props & BoxProps> = React.forwardRef(
  ({ sx, variant = "primary" as "primary", ...restProps }, ref) => (
    <Box
      ref={ref}
      as="button"
      sx={{
        appearance: "none",
        display: "inline-flex",
        alignItems: "center",
        lineHeight: "inherit",
        textDecoration: "none",
        fontSize: "inherit",
        fontFamily: "inherit",
        fontWeight: "bold",
        px: 4,
        py: 2,
        color: "white",
        borderRadius: "default",
        cursor: "pointer",

        "&:disabled": {
          opacity: 0.7,
          cursor: "default",
        },

        ...variants[variant],
        ...(sx as any),
      }}
      {...restProps}
    />
  ),
);

Button.displayName = "Button";

export default Button;
